import React from 'react'
import _ from 'underscore'
import { Target } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import store from '../../state/store'

// The Handed Over / Closed counts are only computed when a specific LS or SDR
// bounds the scan; otherwise their badges are hidden rather than showing a
// misleading 0.
const TERMINAL_COLUMNS = ['closed', 'handed_over']
import PipelineFilters from './filters'
import PipelineTable from './table'
import LoadMore from '../loadmore'

class Pipeline extends React.Component {
  onTabChange = (column_key) => {
    store.emit('pipeline:tab', column_key)
  }

  onLoadMore = () => {
    store.emit('pipeline:load_more')
  }

  render() {
    const p = this.props.pipeline
    const columns = p.stage_columns || []
    const journeys = p.journeys || []
    const counts = p.stage_counts || {}
    const current_tab = p.current_tab || (columns[0] && columns[0].key)

    // Rows carry their real stage column; the All Assigned tab shows them all
    // (the server already excluded Handed Over and Closed).
    const visibleRows = current_tab === 'all_assigned'
      ? journeys
      : _.filter(journeys, (r) => r.column === current_tab)

    return (
      <div className="mx-auto w-full max-w-[1500px] px-6 py-6">
        <Card>
          <CardHeader className="flex flex-wrap items-center gap-2">
            <CardTitle className="flex items-center gap-2">
              <Target className="size-4" />
              Pipeline
            </CardTitle>
            <CardAction className="ml-auto self-center">
              <PipelineFilters pipeline={p} />
            </CardAction>
          </CardHeader>
          <CardContent className="flex flex-col gap-4">
            <Tabs value={current_tab} onValueChange={this.onTabChange}>
              <TabsList className="w-full flex-wrap justify-start group-data-horizontal/tabs:h-auto">
                {columns.map((col) => (
                  <TabsTrigger key={col.key} value={col.key} className="flex-1 gap-1 px-2.5 py-1">
                    {col.name}
                    {TERMINAL_COLUMNS.includes(col.key) && !p.terminal_counts_available ? null : (
                      <Badge variant="secondary" className="h-4 min-w-4 justify-center px-1 text-[11px] tabular-nums">{counts[col.key] || 0}</Badge>
                    )}
                  </TabsTrigger>
                ))}
              </TabsList>
            </Tabs>

            {p.loading ? (
              <div className="py-12 text-center text-sm text-muted-foreground">Loading…</div>
            ) : p.assignment_required ? (
              <div className="py-12 text-center text-sm text-muted-foreground">Select an LS or SDR to load the pipeline.</div>
            ) : visibleRows.length === 0 ? (
              <div className="py-12 text-center text-sm text-muted-foreground">No journeys in this stage.</div>
            ) : (
              <PipelineTable rows={visibleRows} />
            )}

            {p.has_more && !p.loading ? (
              <div className="flex justify-center pb-2">
                <LoadMore
                  key={`pipeline-loadmore-${p.offset}`}
                  loading={p.loading_more}
                  page={Math.floor(p.offset / Math.max(p.per_page, 1))}
                  onLoadMore={this.onLoadMore}
                />
              </div>
            ) : null}
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default Pipeline
